import React, { useEffect, useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import avatecLogo from '../../assets/logos/avatec-white.png';
import './Slide05Scope.css';

function Slide05Scope() {
  const prefersReduced = useReducedMotion();
  const reduceMotion = !!prefersReduced;
  const [isVisible, setIsVisible] = useState(false);
  const ease: [number, number, number, number] = [0.25, 0.46, 0.45, 0.94];

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const fadeUp = (delay = 0) =>
    reduceMotion
      ? { initial: { opacity: 1 }, animate: { opacity: 1 } }
      : {
          initial: { opacity: 0, y: 22 },
          animate: isVisible ? { opacity: 1, y: 0 } : {},
          transition: { duration: 0.7, delay, ease },
        };

  return (
    <div className="slide slide-scope">
      <img src={avatecLogo} alt="Avatec Marine" className="slide-logo" />

      <div className="scope-bg">
        <div className="scope-grid" />
        <div className="scope-orb scope-orb-top" />
        <div className="scope-orb scope-orb-bottom" />
        <div className="scope-noise" />
      </div>

      <div className="scope-content">
        <motion.h1 className="scope-title" {...fadeUp(0.1)}>
          SCOPE OF SERVICES
        </motion.h1>

        <div className="scope-cards">
          <motion.div className="scope-card" {...fadeUp(0.25)}>
            <span className="scope-label">COVERAGE</span>
            <p className="scope-text">
              Avatec Marine provides comprehensive marine technology and service solutions for commercial
              vessels, offshore units, and specialized ships. The company focuses on both newbuilding projects and
              retrofit solutions, supporting vessels throughout their operational life.
            </p>
          </motion.div>

          <motion.div className="scope-card" {...fadeUp(0.4)}>
            <span className="scope-label">CORE ACTIVITIES</span>
            <p className="scope-text">
              The company&apos;s core activities cover <strong>marine electronics, navigation and communication systems,
              automation and safety solutions, connectivity services, onboard support, new installations,</strong> and
              <strong> annual surveys</strong>. Avatec Marine collaborates with shipowners, shipyards, and
              classification societies to ensure full compliance with international standards and operational
              requirements.
            </p>
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default Slide05Scope;
